<template>

  <div class="my-3 row">
    <div class="col-lg-3" v-for="(product,index) in products" :key="index">
      <b-card v-for="(sub_product,index) in subProducts(product)" :key="index*2"
              :id="findHashProductOnLocalStorage(sub_product)+'-col'"
              v-if="findHashProductOnLocalStorage(sub_product) != undefined"
              class="col-lg-12 d-inline-block my-2 mx-1">

        <b-card-text class="content-col">

          <m-img class="product-image col-lg-12" :src="sub_product.thumbnail" :alt="sub_product.name"/>


          <span class="font-weight-bold mt-3 h4">{{ sub_product.name }}</span><br/>

          <div class="discount" v-if="productPriceOnUnAuthShoppingCard(sub_product.offer)['offer'] > 0">
            <span><del>{{ productPriceOnUnAuthShoppingCard(sub_product)['price'] }} تومان</del></span>
          </div>

          <span class="h4">{{
              productPriceOnUnAuthShoppingCard(sub_product)['price'] - productPriceOnUnAuthShoppingCard(sub_product)['offer']
            }} تومان</span>


          <b-row class="mt-2">

            <div class="" v-if="sub_product.is_digital == 0">
              <span class="text">تعداد:</span>

              <span :id="sub_product.id" class="num">{{ getProductNumber(sub_product) }}</span>
              <a class="item-control" @click="increaseProductNumber(sub_product)">
                <b-icon icon="plus"/>
              </a>

              <a class="item-control" @click="decreaseProductNumber(sub_product)">
                <b-icon icon="dash"/>
              </a>
            </div>

            <a class="item-control" @click="removeProduct(sub_product)">
              <b-icon icon="trash"/>
            </a>

          </b-row>
        </b-card-text>
      </b-card>

    </div>
  </div>

</template>

<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {
  subProducts,
  productPriceOnUnAuthShoppingCard
} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {findHashProductOnLocalStorage} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart';


export default {
  name: "UnAuthCard",
  props: ['products'],
  methods: {
    formatNumber,
    subProducts,
    productPriceOnUnAuthShoppingCard,
    findHashProductOnLocalStorage,
    getProductNumber(product) {
      let products = JSON.parse(localStorage.getItem('products'));
      return products[this.findHashProductOnLocalStorage(product)]['quantity']
    },
    increaseProductNumber(product) {
      let products = JSON.parse(localStorage.getItem('products'));
      products[this.findHashProductOnLocalStorage(product)]['quantity']++;
      localStorage.setItem('products', JSON.stringify(products));
      let elementId = String(products[this.findHashProductOnLocalStorage(product)]['id'])
      document.getElementById(elementId).textContent = products[this.findHashProductOnLocalStorage(product)]['quantity'];
    },
    decreaseProductNumber(product) {
      let products = JSON.parse(localStorage.getItem('products'));
      if (products[this.findHashProductOnLocalStorage(product)]['quantity'] > 1) {
        products[this.findHashProductOnLocalStorage(product)]['quantity']--;
        let elementId = String(products[this.findHashProductOnLocalStorage(product)]['id'])
        document.getElementById(elementId).textContent = products[this.findHashProductOnLocalStorage(product)]['quantity'];
      }
      localStorage.setItem('products', JSON.stringify(products));
    },
    removeProduct(product) {
      let products = JSON.parse(localStorage.getItem('products'));

      delete products[this.findHashProductOnLocalStorage(product)];
      let elementId = this.findHashProductOnLocalStorage(product) + '-col'
      document.getElementById(elementId).remove();
      localStorage.setItem('products', JSON.stringify(products));
    },
  },
}
</script>

<style scoped>

.content-col {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
}


.item-control {
  border: none;
  background-color: transparent;
  color: var(--dark);
  width: 20px;
  height: 20px;
}

.num {
  padding: 0 5px 0;
}

.text, .num {
  font-size: 13px;
}


</style>